import { render, staticRenderFns } from "./AssessmentUpdate.vue?vue&type=template&id=7503aa8b&"
import script from "./AssessmentUpdate.vue?vue&type=script&lang=js&"
export * from "./AssessmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports